"use client";

import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";
posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY as string, {
  api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || "https://us.i.posthog.com",
  ui_host: "https://us.i.posthog.com",
  disable_persistence: true,
  disable_surveys: true,
  disable_conversations: true,
  disable_session_recording: true,
  person_profiles: "identified_only",
  defaults: "2025-11-30",
  autocapture: false,
  capture_exceptions: false,
  capture_pageleave: false,
  capture_performance: false,
  capture_heatmaps: false,
  save_referrer: false,
  save_campaign_params: false,
});

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  return <PHProvider client={posthog}>{children}</PHProvider>;
}
